import React from 'react'
import "./Loader.css"

const Loader = () => {
  return (
    <div className= "h-screen flex items-center justify-center">
      <div className='loader'></div>
    </div>
  )
}

export default Loader
